import { Controller } from "@hotwired/stimulus"

// 참여자 입력 form 의 값을 sessionStorage 에 자동 저장하고,
// 페이지 재진입(뒤로 가기·새로고침) 시 복원.
//
// values:
//   key — sessionStorage key (제품별 고유. 예: "participants:PD_XXXXXX")
export default class extends Controller {
  static values = { key: String }

  connect() {
    this.inputs = Array.from(this.element.querySelectorAll('input[name^="participant_"]'))
    this.restore()
    this.inputs.forEach(i => i.addEventListener('input', this.save))
  }

  disconnect() {
    this.inputs.forEach(i => i.removeEventListener('input', this.save))
  }

  save = () => {
    const data = {}
    this.inputs.forEach(i => { data[i.name] = i.value })
    try { sessionStorage.setItem(this.keyValue, JSON.stringify(data)) } catch (_) {}
  }

  restore() {
    let data
    try { data = JSON.parse(sessionStorage.getItem(this.keyValue) || '{}') } catch (_) { data = {} }
    this.inputs.forEach(i => {
      if (i.value || !data[i.name]) return
      i.value = data[i.name]
    })
  }
}
